{
    "ai_modal_title_1": "Migliora il tuo testo con AI",
    "ai_modal_title_2": "Genera nuovo testo utilizzando AI",
    "ai_description": "Usa gli strumenti di generazione di contenuti AI per migliorare i tuoi testi.",
    "ai_learn_more": "Scopri di più",
    "ai_copy_text": "Copia testo",
    "ai_describe_your_text": "Descrivi cosa il tuo testo dovrebbe trattare",
    "ai_describe_your_text_example": "For example, a small description for a craft shop...",
    "ai_new_request": "Crea nuova richiesta",
    "ai_create_text": "Genera testo",
    "ai_apply_text": "Applica testo",
    "ai_try_one_more": "Riprova",
    "ai_correct_errors": "Correggi gli errori",
    "ai_make_longer": "Estendi",
    "ai_make_shorter": "Abbrevia",
    "ai_simplify": "Semplifica",
    "ai_business_tone": "Formale",
    "ai_ceremonial_tone": "Festivo",
    "ai_fun_tone": "Allegro",
    "ai_friendly_tone": "Amichevole",
    "ai_change_tone": "Cambia tono di voce",
    "ai_improve_text": "Migliora il testo",
    "ai_words_number": "Numero di parole:",
    "ai_translate": "Traduci",
    "ai_translate_to_ru": "Traduci in russo",
    "ai_translate_to_en": "Traduci in inglese",
    "ai_add_creativity": "Aggiungi creatività",
    "ai_text_too_large": "Il tuo testo è troppo lungo per utilizzare AI. Rendilo più breve o genera un nuovo testo sull'argomento richiesto con l'aiuto di AI.",
    "ai_translate_to_ua": "Traduci in ucraino",
    "ai_translate_to_es": "Traduci in spagnolo",
    "ai_translate_to_pt": "Traduci in portoghese",
    "ai_translate_to_tr": "Traduci in turco",
    "ai_translate_to_fr": "Traduci in francese",
    "ai_translate_to_de": "Traduci in tedesco",
    "ai_translate_to_it": "Traduci in italiano",
    "ai_translate_to_pl": "Traduci in polacco",
    "ai_free_request_error": "Le richieste gratuite sono terminate",
    "ai_free_request_number": "Numero della richiesta: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "È possibile utilizzare fino a 200 richieste di strumenti AI gratuite. Per fare più richieste, attiva le tue chiavi API al provider AI nelle impostazioni del tuo account.",
    "cancel": "Annulla",
    "gpt_error_quota": "Hai raggiunto il limite di richieste API. Per continuare a utilizzare gli strumenti AI, controlla il tuo limite attuale o aggiungi fondi al tuo saldo nelle impostazioni dell'account OpenAI.",
    "ai_generated_disclaimer": "Sei responsabile del testo generato. Controllalo prima di pubblicarlo."
}
